module.exports = __webpack_public_path__ + "static/img/triangle.c3128159.svg";